import { render, staticRenderFns } from "./speakerForm.vue?vue&type=template&id=2c705d46&"
import script from "./speakerForm.vue?vue&type=script&lang=js&"
export * from "./speakerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports